import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useTabFromQueryParam = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    const tabIndex = Number.parseInt(new URLSearchParams(location.search).get('tabIndex') || '0');
    setActiveTab(tabIndex);
  }, [location.search]);

  const goToTab = (tab: number) => {
    setActiveTab(tab);
    navigate(`${location.pathname}?tabIndex=${tab}`, { replace: true });
  };

  return { activeTab, goToTab };
};
